<div [@zoomInOnEnter] class="sessionCard mat-elevation-z2" role="region">
	<div class="headerRow">
		<label class="headerLabel">
			{{ session().title }}
		</label>
		@if (showActionMenu()) {
			<sim-action-menu [actions]="[{fontIcon: 'fa-edit', click: openEdit(), labelKey: T.BUTTON_EDIT}]" (onDelete)="confirmDelete()" />
		}
	</div>
	<div class="headerRow">
		<label class="secondaryLabel">
			<mat-icon fontIcon="fa-cubes" fontSet="fa" />
			{{ session().type | enumLabel: EnumLabel.SessionType }}
		</label>

		<label class="secondaryLabel">
			<mat-icon fontIcon="fa-clock" fontSet="far" />
			{{ session().startTime | timeRangeLabel: session().displayEndTime }}
		</label>

		<!--TAGS-->
		<div class="statusTags">
			<!--SESSION REPLICATION STATE TAG-->
			<ng-container *hasPermission="'Exam_Organizer'">
				@if (isArchiveView() && isStudentPortalAvailable()) {
					<!--TODO: Check ACL permissions-->
					<sim-session-replication-state-tag
						[sessionReplicationState]="sessionReplicationState()"
						[sessionReplicationStateError]="sessionReplicationStateError()"
					/>
				}
			</ng-container>

			<!--SESSION STATUS TAG-->
			<sim-session-status-tag [isValid]="session().isValid" [status]="session().state" />
		</div>
	</div>
	<section class="cardContent">
		<!--CONFIRMATION/CLOSING PANEL-->
		<div class="panelRow">
			<div class="panel">
				<label>
					<mat-icon fontIcon="fa-user-check" fontSet="fa" />
					{{ T.LABEL_EXAM_CONFIRMATION | translate }}
				</label>
				<label class="secondaryLabel">
					<mat-icon fontIcon="fa-alarm-clock" fontSet="far" />
					<span>
						{{ session().startTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
						{{ confirmationEnd() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
					</span>
				</label>
			</div>

			<div class="panel">
				<label>
					<mat-icon fontIcon="fa-portal-exit" fontSet="fa" />
					{{ T.LABEL_EXAM_CLOSING | translate }}
				</label>
				<label class="secondaryLabel">
					<mat-icon fontIcon="fa-alarm-clock" fontSet="far" />
					<span>
						{{ closingStart() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
						{{ session().displayEndTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
					</span>
				</label>
			</div>
		</div>

		<!--EXAM PANEL-->
		<div class="panel mainPanel">
			<label>
				<mat-icon fontIcon="fa-cubes" fontSet="fas" inline />
				{{ T.SESSION_TYPE_EXAM | translate }}
			</label>
			<div class="panelBody">
				<div class="infoRow">
					<div>
						<label class="secondaryLabel">
							<mat-icon fontIcon="fa-alarm-clock" fontSet="far" inline />
							{{ T.LABEL_DURATION | translate }}
						</label>
						<span>
							{{ confirmationEnd() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
							{{ closingStart() | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
						</span>
					</div>
					<div>
						<label class="secondaryLabel">
							<mat-icon fontIcon="fa-repeat" fontSet="fas" inline />
							{{ T.LABEL_RUN | translate }}
						</label>
						<span>
							{{
								session().scheduleSettings.runMode === ExamFlowRunMode.SingleRun
									? 1
									: session().scheduleSettings.runMode === ExamFlowRunMode.NRun
										? Math.min(session().examStations?.length, session().scheduleSettings.nRunMaxRuns)
										: session().examStations?.length
							}}
						</span>
					</div>
					<div>
						<label class="secondaryLabel">
							<mat-icon fontIcon="fa-folder-tree" fontSet="fas" inline />
							{{ T.LABEL_EXAM_FLOW | translate }}
						</label>
						<a (click)="openExamFlowDetailDialog()">
							{{ examFlow.value()?.name }}
						</a>
					</div>
				</div>
				<mat-divider [hasPermission]="Permissions.ExamDetails_ViewAll" />
				<sim-session-station-preview
					[contentTemplate]="stationContent"
					[hasPermission]="Permissions.ExamDetails_ViewAll"
					[stations]="session().examStations"
				/>
			</div>
		</div>
	</section>

	<!--ACTIONS-->
	<section class="actionsFooter">
		<ng-content select="[actions]" />
		@if (!disableControls()) {
			@if (isArchiveView()) {
				@if (isStudentPortalAvailable() && sessionReplicationState()) {
					<ng-container *hasPermission="'Exam_Organizer'">
						<!--SET STUDENT PORTAL AVAILABILITY-->
						<sim-button
							(onClick)="openSessionReplicationSettingsDialog()"
							[icon]="{fontSet: 'fad', fontIcon: 'fa-user-clock'}"
							[label]="T.EVENT_SESSION_OPEN_REPLICATION_SETTINGS"
						/>
					</ng-container>
				}
				<!--OPEN IN ARCHIVE-->
				<sim-button
					(onClick)="openExamSession()"
					[disabled]="isExamSchedule() && !session().schedule?.length"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-edit'}"
					[label]="T.SHARED_BASIC_ADMINISTRATION_TABLE_EDIT"
				/>
			} @else if (session().state !== SessionState.Draft) {
				<ng-container *hasPermission="'Exam_Organizer'">
					<!--ABORT SESSION-->
					@if (canCancelSession()) {
						<button mat-raised-button color="warn" (click)="cancelSession()">
							{{ T.EVENT_SESSION_EXAM_SESSION_ABORT_SESSION_BTN_TXT | translate }}
						</button>
					}
					<!--MC APP-->
					@if (canOpenMasterOfCeremony()) {
						<button mat-raised-button color="accent" (click)="openMasterOfCeremonyApp()">
							{{ T.EVENT_SESSION_EXAM_SESSION_OPEN_MASTER_OF_CEREMONY_APP_BTN_TXT | translate }}
						</button>
					}
					<!--CONFIRMATION APP-->
					@if (canOpenConfirmation()) {
						<button mat-raised-button color="accent" (click)="openConfirmationApplication()">
							{{ T.EVENT_SESSION_EXAM_SESSION_OPEN_CONFIRMATION_APP_BTN_TXT | translate }}
						</button>
					}
					<!--START SESSION-->
					@if (canStartSession()) {
						<div
							[matTooltip]="startExamSessionErrorTooltip() | translate"
							[matTooltipDisabled]="!startExamSessionErrorTooltip()"
						>
							<sim-button
								(onClick)="startExamSession()"
								[label]="T.EVENT_SESSION_EXAM_SESSION_START_CONFIRMATION_BTN_TXT"
								[icon]="{fontSet: 'fas', fontIcon: 'fa-play-circle'}"
								[disabled]="!!startExamSessionErrorTooltip()"
								[appBusy]="busyPromise()"
								color="accent"
							/>
						</div>
					}
				</ng-container>
			}
		}
	</section>
</div>

<!--STATION CONTENT TEMPLATE-->
<ng-template #stationContent let-context>
	<sim-exam-session-card-station-content [examSession]="session()" [index]="context.index" [station]="context.station" />
</ng-template>
